import PostDigitalDonationReceiptFormRequestModel from '../../generated/types/model/resource/PostDigitalDonationReceiptFormRequestModel';

export default class PostDigitalDonationReceiptFormRequestViewModel extends PostDigitalDonationReceiptFormRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
